<template>
  <div>
    <Button @click="resetParams" style="margin-right: 5px">重置</Button>
    <Button type="text" style="color: #2d8cf0" @click="modal.visible = true">高级搜索</Button>
    <Modal title="高级搜索" v-model="modal.visible" :width="410">
      <div v-for="(item,index) in modal.list" :key="index" style="margin-bottom: 7px">
        <!-- {{item}} -->
        <Select v-model="item.key" placeholder="选择搜索条件" style="width: 180px" @on-change="setKey($event,item)">
          <Option v-for="(it,i) in modal.data" :key="i" :value="it.key" :disabled="hideOption(it)">{{it.name}}</Option>
        </Select>
        <Input v-if="item.type === 'input'" v-model="item.val" style="width: 180px;margin-left: 15px;" placeholder="输入搜索值"/>
        <Select v-if="item.type === 'select'" v-model="item.val" style="width: 180px;margin-left: 15px;" placeholder="选择搜索值">
          <Option v-for="(it,i) in objectData[item.key].searchOption.vals" :key="i" :value="it.val">{{it.name}}</Option>
        </Select>
      </div>
      <div class="t-center" style="margin-top: 25px;">
        <Button type="primary" @click="modal.list.push({type: 'input',key: '',val: ''})">新增条件</Button>
      </div>
      <div slot="footer">
        <Button @click="modal.visible = false">取消</Button>
        <Button @click="setParams" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  export default {
    name: "SeniorSearch",
    props: {
      data: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        modal: {
          visible: false,
          data: [],                 // 条件常亮
          list: [{type: "input",key: "",val: ""}],  // 条件最终值
        },
        objectData: {}
      }
    },
    mounted(){
      this.formatData()
    },
    methods: {
      resetParams(){
        this.$emit('getParams',{})
      },
      setParams(){
        let temp = {}
        this.modal.list.map(item=>{
          temp[item.key] = item.val
        })
        this.$emit('getParams',temp)
        this.modal.visible = false;
      },
      hideOption(data){
        let flag = false
        this.modal.list.map(item=>{
          if(item.key === data.key){
            flag = true
            return
          }
        })
        return flag
      },
      setKey(key,data){
        data.val = "";
        data.type = this.objectData[key].searchOption?this.objectData[key].searchOption.type?this.objectData[key].searchOption.type:"input":"input"
      },
      formatData() {
        let temp = JSON.parse(JSON.stringify(this.data));
        temp.map(item=>{
          if(item.search){
            this.objectData[item.key] = item
            this.modal.data.push({
              key: item.key,
              name: item.title,
              ...item.searchOption
            })
          }
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
